// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"43cd0988","580":"d22b45eb","807":"b4ad2200"}[chunkId] + ".chunk.css";
};